import { AbstractControl, AsyncValidatorFn, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ProductService } from '../../../../../services/product/product.service';
import { catchError, debounceTime, map, Observable, of } from 'rxjs';

// Arabic characters validator
export function arabicCharactersValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value || value.trim() === '') {
      return null;
    }

    // Just ensure at least one Arabic character exists, don't restrict the rest
    const containsArabic = /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;
    if (!containsArabic.test(value)) {
      return { arabicCharacters: true };
    }

    return null;
  };
}
export function englishCharactersValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    // Skip validation if empty (field is optional)
    if (!value || value.trim() === '') {
      return null;
    }

    // Must contain valid English characters (letters, numbers, spaces, common punctuation)
    const englishPattern = /^[a-zA-Z0-9\s.,'\-()\u00AE\u2122®™%/:]+$/;
    if (!englishPattern.test(value.trim())) {
      return { englishCharacters: true };
    }

    return null;
  };
}

export function numericOnlyValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value === null || value === '') return null; // optional field, skip if empty

    if (isNaN(value) || (typeof value === 'string' && value.trim() === '')) {
      return { numericOnly: true };
    }

    return null;
  };
}

export function barcodeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    // Optional — skip if empty
    if (value === null || value === undefined || value.toString().trim() === '') {
      return null;
    }

    const strValue = value.toString().trim();

    // Cannot contain only spaces
    if (strValue === '') {
      return { barcodeEmpty: true };
    }

    // Only numeric characters allowed
    if (!/^\d+$/.test(strValue)) {
      return { barcodeNumericOnly: true };
    }

    // Standard barcode format lengths: EAN-8, UPC-A, EAN-13, ITF-14
    const validLengths = [13];
    if (!validLengths.includes(strValue.length)) {
      return { barcodeInvalidFormat: true };
    }

    return null;
  };
}
